import { useSelector } from 'react-redux';
import { createSelector } from '@reduxjs/toolkit';


const loginState = (state) => {
    return state.persistedReducer.loginReducer;
}

// same input and output state to maintain architecture
// export const loginState = (appState) => createSelector(appState,(state)=>{
//     return state
// })

export const getLoginStateSelector = () => createSelector(loginState,(state)=>{
    return state
})